import request from "@/utils/request";

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  };
  return request({
    url: "/login",
    method: "post",
    data: data
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: "/getInfo",
    method: "get"
  });
}

// 退出方法
export function logout() {
  return request({
    url: "/logout",
    method: "post"
  });
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: "/captchaImage",
    method: "get"
  });
}
// 获取短信验证码
export function getMesCode(data) {
  return request({
    url: "/loginOtpCode",
    method: "post",
    data
  });
}
// 校验图形验证码并发送随机验证码短信
export function captchaOtpCode(data) {
  return request({
    url: "/captchaOtpCode",
    method: "post",
    data
  });
}
// 重置密码
export function forgetPwd(data) {
  return request({
    url: "/system/manager/forgetPwd",
    method: "post",
    data
  });
}
